import { render, staticRenderFns } from "./numero.vue?vue&type=template&id=251180b5&scoped=true&"
import script from "./numero.vue?vue&type=script&lang=js&"
export * from "./numero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251180b5",
  null
  
)

export default component.exports